module.exports = require('./helpers/bundle-url').getBundleURL('3KKoK') + "annotation-severity-high-icon.06924edc.svg";